import React, { memo } from "react";
import { useIntl } from "react-intl";
import { StModuleContainer } from "@mediamath/design-system-eng";
import ModuleHeader from "core/shared/presenter/ModuleHeader";
import TabRouterContainer from "core/layout/container/TabRouterContainer";
import ReportsMessages from "reports/intl/ReportsMessages";
import useReportsModuleTabs from "reports/hooks/useReportsModuleTabs";

const ReportsModuleTabs = memo(() => {
  const { formatMessage } = useIntl();
  const headline = formatMessage(ReportsMessages.reports);
  const tabs = useReportsModuleTabs();

  return (
    <StModuleContainer>
      <ModuleHeader paddingBottom="0px" headline={headline} />
      <TabRouterContainer basePath="/reports" tabs={tabs} />
    </StModuleContainer>
  );
});

export default ReportsModuleTabs;
